import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Home from "@/pages/Home";
import MenuPage from "@/pages/MenuPage";
import LegalPage from "@/pages/LegalPage";
import QrRedirect from "@/pages/QrRedirect";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import MenuItems from "@/pages/admin/MenuItems";
import Categories from "@/pages/admin/Categories";
import Reservations from "@/pages/admin/Reservations";
import Messages from "@/pages/admin/Messages";
import Gallery from "@/pages/admin/Gallery";
import Reviews from "@/pages/admin/Reviews";
import QRMenu from "@/pages/admin/QRMenu";
import LegalPages from "@/pages/admin/LegalPages";
import Settings from "@/pages/admin/Settings";
import { CookieBanner } from "@/components/site/CookieBanner";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return <div className="min-h-screen grid place-items-center ym-dark eyebrow" data-testid="admin-loading">Yükleniyor…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  return children;
}

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/menu" element={<MenuPage />} />
              <Route path="/yasal/:slug" element={<LegalPage />} />
              <Route path="/qr/:code" element={<QrRedirect />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
                <Route index element={<Dashboard />} />
                <Route path="menu" element={<MenuItems />} />
                <Route path="kategoriler" element={<Categories />} />
                <Route path="rezervasyonlar" element={<Reservations />} />
                <Route path="mesajlar" element={<Messages />} />
                <Route path="galeri" element={<Gallery />} />
                <Route path="yorumlar" element={<Reviews />} />
                <Route path="qr-menu" element={<QRMenu />} />
                <Route path="yasal-metinler" element={<LegalPages />} />
                <Route path="ayarlar" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <CookieBanner />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </SiteProvider>
    </div>
  );
}

export default App;
